import { pubText } from "../../i18n/publicTranslation";
import { GraphicEqRounded } from '@mui/icons-material';

type Stage = 'blueprint' | 'script' | 'audio' | 'storyboard';

const waveform = [18, 38, 70, 44, 90, 58, 32, 76, 100, 62, 40, 82, 56, 30, 64, 46, 24, 48, 36, 16];

// Actual workspace captures with enlarged details from the same story.
// The surrounding cutouts and waveform are decorative marketing treatments.
export default function GambitStageVisual({ stage, alt }: { stage: Stage; alt: string }) {
  return (
    <div className={`creation-stage-visual creation-stage-visual--${stage}`}>
      <div className="creation-workspace-image">
        <img
          src={`/images/gambit/workspace-${stage}.webp`}
          alt={pubText(alt)}
          width="1600"
          height="900"
          loading="lazy"
        />
      </div>
      <div className="creation-stage-details" aria-hidden="true">
        {pubText(stage === 'blueprint' && (
          <img
            className="creation-cutout creation-cutout--cast"
            src="/images/how-it-works/cleo-cutout.webp"
            alt={pubText("")}
            width="500"
            height="439"
            loading="lazy"
          />
        ))}
        {pubText(stage === 'script' && (
          <div className="creation-dialogue-detail">
            <span className="creation-detail-label">{pubText("Cleo")}</span>
            <span className="creation-delivery-note">{pubText("Hushed")}</span>
            <p>{pubText("“It’s calling.”")}</p>
          </div>
        ))}
        {pubText(stage === 'audio' && (
          <div className="creation-audio-detail">
            <div className="creation-audio-detail-heading">
              <GraphicEqRounded />
              <strong>{pubText("Cinematic audio")}</strong>
              <span>1:33</span>
            </div>
            <div className="creation-waveform">
              {pubText(waveform.map((height, index) => (
                <i key={index} style={{ height: `${height}%` }} />
              )))}
            </div>
          </div>
        ))}
        {pubText(stage === 'storyboard' && (
          <>
            <img
              className="creation-scene creation-scene--pearl"
              src="/images/how-it-works/eighth-wakes-pearl.webp"
              alt={pubText("")}
              width="540"
              height="960"
              loading="lazy"
            />
            <img
              className="creation-scene creation-scene--guardian"
              src="/images/how-it-works/eighth-wakes-guardian.webp"
              alt={pubText("")}
              width="540"
              height="960"
              loading="lazy"
            />
          </>
        ))}
      </div>
    </div>
  );
}
